<!--
Desc: 转托管入直销
-->
<template>
    <div class="transferCombTrusteeIn-container">
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            class="pwdForm"
            label-position="right"
            label-width="120px"
            v-on:submit.native.prevent
        >
            <el-form-item label="原申请单编号：" prop="originalappsheetno" class="form-text">
                <el-input
                    v-model.trim="fundInfo.originalappsheetno"
                    class="prefix"
                    placeholder="请输入原申请单编号"
                    :maxlength="20"
                />
            </el-form-item>
            <el-form-item label="基金名称：" prop="fundcode" class="form-text">
                <el-select v-model="fundInfo.fundcode" placeholder="请选择基金" filterable>
                    <el-option
                        v-for="item in fundcodeLists"
                        :key="item.fundcode"
                        :label="item.fundname + '（' + item.fundcode + '）'"
                        :value="item.fundcode"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="收费方式：" prop="sharetype" class="form-text">
                <el-select v-model="fundInfo.sharetype" placeholder="请选择收费方式">
                    <el-option
                        v-for="item in shareTypeLists"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="转出机构：" prop="targetdistributorcode" class="form-text">
                <el-select
                    v-model="fundInfo.targetdistributorcode"
                    placeholder="请选择转出机构"
                    filterable
                >
                    <el-option
                        v-for="item in bankcodeLists"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="转入卡：" prop="bankcode" class="form-text">
                <el-select v-model="fundInfo.bankcode" placeholder="请选择转入卡">
                    <el-option
                        v-for="(item, index) in bankcardLists"
                        :key="index"
                        :label="item.channelDisplayText"
                        :value="item.transactionaccountid"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" class="form-text">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="20"
                />
                <span
                    style="position: absolute; width: 85px"
                    class="redemp-btn"
                    v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                >
                    <span class="like-a">忘记密码？</span>
                </span>
            </el-form-item>
            <el-form-item class="form-text">
                <div>
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="checkBuy == false"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        确定
                        <span id="time"></span>
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <div
            v-if="
                $cache.getParamValue('prompt_info') &&
                $cache.getParamValue('prompt_info').transferstep
            "
        >
            <div class="tips-title">
                <div class="info-tips">!</div>
                <div>温馨提示</div>
            </div>
            <div
                class="step-tip top-16"
                v-html="$cache.getParamValue('prompt_info').transferstep"
            ></div>
        </div>
        <result
            v-if="buySuccess"
            :result="result"
            v-on:return-page="$router.push({ name: 'traderecord' })"
            v-on:return-login="$router.push({ name: 'home' })"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import commonApi from "@/api/common";

export default {
    name: "TrusteeshipFund",
    components: { result },
    mixins: [mixin],
    data() {
        return {
            shareTypeLists: [],
            fundcodeLists: [],
            bankcodeLists: [],
            bankcardLists: [],
            fundInfo: {
                transactionaccountid: "",
                targettransactionaccountid: "",
                targetdistributorcode: "", // 转出机构
                pwd: "",
                sharetype: "", // 收费方式
                originalappsheetno: "", // 原申请单编号
                fundcode: "", // 基金
                targetbranchcode: "", // 转出机构
                bankcode: "" // 转入卡
            },
            checkBuy: true,
            isPwdCheck: false,
            isAmountAll: false,
            fund: {}, // 基金信息获取
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的转托管入直销申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            query: null,
            rules: {
                originalappsheetno: [
                    { required: true, message: "请输入原申请单编号", trigger: "blur" }
                ],
                fundcode: [{ required: true, message: "请选择基金", trigger: "change" }],
                sharetype: [{ required: true, message: "请选择收费方式", trigger: "change" }],
                targetdistributorcode: [
                    { required: true, message: "请选择收转出机构", trigger: "change" }
                ],
                bankcode: [{ required: true, message: "请选择转入卡", trigger: "change" }],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {},
    mounted() {
        this.$util.queryValidPwdTrdMethod("027", (res) => {
            this.isPwdCheck = res;
        });
        this.qryFundLists();
        this.qryBankCards();
        this.shareTypeLists = this.$cache.getDict("130000");
        this.bankcodeLists = this.$cache.getDict("110070");
    },
    methods: {
        async qryFundLists() {
            const res = await fundApi.getFundLists({
                keyword: "",
                pagesize: "999",
                pagenum: "1"
            });

            if (res.data && res.data.list && res.data.list.length) {
                this.fundcodeLists = res.data.list || [];
            }
        },
        async qryBankCards() {
            const reqRes = await userApi.getMyBankCards();

            if (reqRes.data) {
                const bankLists = reqRes.data.data.filter((item) => {
                    return (
                        item.authenticateflag === "1" && // 已鉴权才能购买
                        item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常 空是支付方式停用银行卡）
                    );
                });
                this.bankcardLists = bankLists || [];
                // 预处理渠道数据
                if (this.bankcardLists && this.bankcardLists.length > 0) {
                    this.bankcardLists.forEach((item) => {
                        this.$util.preprocessChannelData(item);
                    });
                }
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.trusteeshipFund();
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 发起转托管
        async trusteeshipFund(val) {
            const _this = this;

            try {
                let res = await fundApi.combTrusteeIn({
                    originalappsheetno: _this.fundInfo.originalappsheetno,
                    fundcode: _this.fundInfo.fundcode,
                    sharetype: _this.fundInfo.sharetype,
                    targetdistributorcode: _this.fundInfo.targetdistributorcode,
                    transactionaccountid: _this.fundInfo.bankcode,
                    tradepassword: this.isPwdCheck ? this.$util.enc(_this.fundInfo.pwd) : null
                });
                console.log(112233, res);

                if (res.data) {
                    this.result.cla = "register-success";
                    this.result.btnMsg = "";
                } else {
                    this.result.cla = "register-fail";
                    this.result.btnMsg = "原因：" + res.msg;
                }
                const prefix = "您的转托管入直销申请已提交";
                this.result.msg = prefix + (this.result.cla === "register-fail" ? "失败" : "成功");
                this.buySuccess = true;
            } catch (error) {
                this.$log.error(error);
            }
        }
    }
};
</script>
<style lang="scss">
.bizcomp-trusteeship-fund {
    .el-radio-group.bank-radio .el-radio {
        margin-top: 10px;
    }
    .back {
        color: var(--color-text-regular);
        background: var(--color-divided);
        border-color: transparent;
    }
    .bank-img-sel {
        box-sizing: border-box;
        width: 550px !important;
    }
    .check-text {
        padding-left: 5px;
        color: var(--color-highlight);
    }
    .cursor-pointer {
        cursor: pointer;
    }
}
</style>
<style lang="scss" scope>
.transferCombTrusteeIn-container {
    .pwdForm {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .form-text {
        margin-bottom: 20px !important;
    }

    .tips-title {
        font-size: 18px;
        font-weight: 600;
        display: flex;
        color: var(--color-text-primary);
        line-height: 20px;
        margin-left: 12px;
        margin-top: 20px;
    }

    .info-tips {
        height: 18px;
        width: 18px;
        border-radius: 9px;
        color: var(--color-text-white);
        background-color: red;
        font-size: 16px;
        text-align: center;
        margin-right: 8px;
    }

    .step-tip {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: var(--color-text-primary);
        line-height: 19px;
        text-align: justify;
        font-style: normal;
        margin-top: 2px;
    }

    .top-16 {
        margin-top: 16px;
    }

    .bold {
        font-weight: 600;
    }
}
</style>
